import aiMl from "../../images/cms_images/ai-ml.webp";
import cmsIot from "../../images/cms_images/iot.webp";

export const pythonAssets = {
  python: {
    emerging: {
      emerging1: aiMl,
      emerging2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/emerging/ar-vr.webp`,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/emerging/natural-language-processing.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/emerging/computer-vision.webp`,
      emerging5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/emerging/deep-learning.webp`,
      emerging6: cmsIot,
    },
    process: {
      process1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/discovery.webp`,
      process2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/design.webp`,
      process3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/development.webp`,
      process4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/testing.webp`,
      process5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/deployment.webp`,
      process6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/process/software-and-maintenance.webp`,
    },
    services: {
      service1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/python-development-consulting.svg`,
      service2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/python-web-development.svg`,
      service3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/python-mobile-app-development.svg`,
      service4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/machine-learning-solutions-with-python.svg`,
      service5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/python-upgradation-and-migration.svg`,
      service6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/services/python-maintenance-support.svg`,
    },
    whyKonstant: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/solid-understanding-of-python-versions.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/protecting-intellectual-property.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/fully-equipped-infrastructure.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/support-and-low-risk-factor.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/advanced-innovation.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whykonstant/diverse-exposure.svg`,
    },
    whyPython: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/improved-scalability.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/cost-effective-development.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/built-in-libraries.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/platform-independent.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/availability-of-frameworks.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Pythonpage/whypython/thriving-community.svg`,
    },
    bg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/python_bg.svg`,
  },
};
